<template>
  <div v-if="!sold" class="row no-gutters">
    <div class="col mb-sm-3">
      <div class="col-inner p-3 bg-white rounded">
        <div class="d-md-flex gap-3">
          <div class="col-md-3">
            <a :href="`/auctions/${this.auction_id}/lots/${lot.id}`">
              <img
                :src="lot.images.length > 0 ? `/storage/${lot.images[0].path}` : '/images/cars/no_image.jpg'"
                class="img-fluid card-img"
                alt="car"
              >
            </a>
          </div>
          <div class="col">
            <h5 class="black-small-heading">
              <a :href="`/auctions/${this.auction_id}/lots/${lot.id}`">
                {{lot.car.name}}
              </a>
            </h5>
            <span class="mb-2 font-s14 fw-bold-500 d-block text-start fst-italic">
             {{ lot.car.subtitle}}
            </span>
            <fix-price-control-panel-component
              :lot="lot"
              :reserve_time="reserve_time"
              mode="compact"
              @sold="sold=true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FixPriceControlPanelComponent from "../lots/fixprice/FixPriceControlPanelComponent.vue";

export default {
  components: {FixPriceControlPanelComponent},

  props: ['lot', 'auction_id', 'reserve_time'],
  data() {
    return {
      sold: false,
    }
  },
}
</script>

<style scoped>
</style>

